import React from 'react';

const DataTransactionsIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18.05 8.51l1.41 1.41 4.25-4.24a1 1 0 0 0 0-1.41L19.46 0l-1.41 1.44L20.59 4H0v2h20.59zM6 15.46l-1.46-1.41-4.25 4.24a1 1 0 0 0 0 1.42L4.54 24 6 22.54 3.41 20H24v-2H3.41z"/></svg>    )
};

export default DataTransactionsIcon;